export const objectToURIComponent = (data: {[key: string]: string}): string => Object.keys(data)
    .filter(analyticsKey => data[analyticsKey])
    .map(analyticsKey => `${analyticsKey }=${ encodeURIComponent(data[analyticsKey])}`)
    .join('&');
